export * from './teamid2teamname.directive';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/teamid2teamname/index.ts